/** Is `value` a well-formed selection for this market? Fixed-option markets accept
 *  only a listed option value; `exact` accepts an "H-A" score; `player` accepts a
 *  provider id token. Used by entry validation so a client can't submit a garbage
 *  (or impossible-to-grade) selection. */
export function isValidSelectionValue(m, value) {
    if (typeof value !== 'string' || value.length === 0)
        return false;
    if (m.options)
        return m.options.some((o) => o.value === value);
    if (m.kind === 'exact')
        return /^\d{1,2}-\d{1,2}$/.test(value);
    if (m.kind === 'player')
        return /^[A-Za-z0-9_-]{1,32}$/.test(value);
    return false;
}
//# sourceMappingURL=validation.js.map